import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import LeftImgrightContent from "../../Components/internal-pages/Leftimg_rightContent";
import RightimgLeftContent from "../../Components/internal-pages/Rightimg_leftContent";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import Pageheader from "../../Components/internal-pages/Page_header";


const AbouteYantra = () => {
  const [viewMore, setViewMore]= useState(false);
  const CTAContent = [
    {
      pageHeaderName: "Goal ",
      pageParagraphitalic: "Shaping Success Through Connection ",
      pageParagraphText:
        "At eYantra, our goal is simple yet impactful: to encourage businesses by creating memorable corporate gifting experiences. We specialize in branded merchandise, corporate gifting, and innovative recognition solutions designed to leave a lasting impression. Whether it’s employee gifts, joining kits, or festive gifting, we aim to bridge the gap between brands and their employees, creating connections that inspire loyalty and drive success. ",
      ContactFormName: "About-eYantra",
    },
  ];
  const handleViewMore =  ()=>{
    setViewMore(Prev=> !Prev)

  }

  const ContentImg = [
    {
      index: 0,
      leftImg: "../assests/images/who-we-are/Culture of Work.jpg",
      leftHeading: "Culture of Work",
      leftSmallpara: "Collaboration and Creativity ",
      leftParagraph:
        "We thrive on innovation, teamwork, and a relentless focus on excellence along with celebrating the power of ideas and the energy of collaboration. We believe in nurturing relationships – with clients, employees, and communities. This people-first approach fuels our creative spirit, enabling us to craft solutions that not only meet but exceed expectations. Together, we foster an environment where every voice matters, and every idea has the potential to make an impact. ",
      leftRedirectUrl: "/contact-us",
    },
    {
      index: 1,
      leftImg: "../assests/images/who-we-are/Locations.jpg",
      leftHeading: "Locations ",
      leftSmallpara: "Global Presence With A Local Touch ",
      leftParagraph: 
      <>
      <p>
        With a robust network of offices and distribution centres, eYantra makes sure to have seamless operations across India. Our presence spans major metropolitan hubs, bringing us closer to the businesses and communities we serve. From Mumbai to Delhi, Bengaluru to Hyderabad, we blend global expertise with a deep understanding of local markets, making us a trusted partner for businesses everywhere.</p>
        <p>
        {viewMore && (
        <p>
          eYantra isn’t just a brand; it’s an experience. It’s where passion meets precision, creativity meets commitment, and brands meet their audiences in the most meaningful ways.
        </p>
        )
      }
        <p className="text-start fw-bold p-0 m-0" onClick={handleViewMore} style={{cursor:'pointer'}}>
                {viewMore ? 'View Less' : 'View More'}
        </p>
        
        </p>
      </>,
      leftRedirectUrl: "/contact-us",
    },
  ];

  const rightImgContent = [
    {
      index: 0,
      rightImg: "../assests/images/who-we-are/Leadership.jpg",
      rightHeading: "Leadership",
      rightSmallpara: "Visionaries Behind the Brand",
      rightParagraph:
        "Our leadership team is driven by a shared passion for innovation and excellence. With decades of combined expertise across industries, they provide the strategic direction and inspiration that define eYantra. They are the guiding force behind our commitment to quality, sustainability, and customer-centric solutions. At eYantra, leadership means empowering teams, embracing challenges, and always striving for the extraordinary.",
      rightRedirectUrl: "/contact-us",
    },
  ];


  return (
    <>
      <Helmet>
        <title>About - eYantra </title>
      </Helmet>
      <div className="p-0 m-2">
        <Pageheader data={CTAContent} />
        <div id="culture-of-work">
        <LeftImgrightContent leftImgContent={ContentImg[0]} />
        </div>
        <div className="p-0 m-0" id="leadership">
        <RightimgLeftContent data={rightImgContent[0]} />
        </div>
        <div className="p-0 m-0" id="locations">
        <LeftImgrightContent leftImgContent={ContentImg[1]} id="locations"/>
        </div>


        <div className="my-5">
          <ClinetsLogoSlider />
        </div>
        <Whychooseus />
      </div>
    </>
  );
};

export default AbouteYantra;
